// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, ellipsis, getSystemColor } from "@adl/XDL/Utilities";
import { LinkPresentationProps } from "@insite/mobius/Link/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { css } from "styled-components";

interface HeaderAutoCompleteItemsStyles {
    headerText?: TypographyPresentationProps;
    itemText?: TypographyPresentationProps;
    focusedItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
}

const headerAutoCompleteItemsStyles: HeaderAutoCompleteItemsStyles = {
    headerText: {
        size: 16,
        weight: "bold",
        css: css`
            background: ${color("common.ui9")};
            width: 100%;
            ${ellipsis(1)}
            padding: 15px 20px;
            letter-spacing: 0;
            line-height: 17px;
            &:not(:first-child) {
                margin-top: 15px;
            }
        `,
    },
    itemText: {
        size: 15,
        color: "text.main",
        weight: "normal",
        css: css`
            width: 100%;
            text-align: left;
            ${ellipsis(1)}
            letter-spacing: 0;
            line-height: 34px;
            padding: 0 20px;
            &:hover {
                cursor: pointer;
                background-color: ${color("common.ui1", 0.25)};
            }
            & > span[class^="StyledButton-sc"] {
                padding: 0;
                background-color: transparent;
            }
        `,
    },
    focusedItemText: {
        size: 15,
        color: "text.main",
        weight: "normal",
        css: css`
            width: 100%;
            text-align: left;
            cursor: pointer;
            background-color: ${color("common.ui1", 0.25)};
            ${ellipsis(1)}
            letter-spacing: 0;
            line-height: 34px;
            padding: 0 20px;
        `,
    },
    link: {
        color: "text",
        typographyProps: {
            size: 15,
            color: "text",
            weight: "normal",
            css: css`
                width: 100%;
                text-align: left;
                ${ellipsis(1)}
                letter-spacing: 0;
                line-height: 34px;
            `,
        },
        hoverStyle: {
            color: getSystemColor("text.main"),
        },
        css: css`
            padding: 0 20px;
            &:hover {
                background-color: ${color("common.ui1", 0.25)};
            }
        `,
    },
    focusedLink: {
        color: "text",
        typographyProps: {
            size: 15,
            color: "text",
            weight: "normal",
            css: css`
                width: 100%;
                text-align: left;
                ${ellipsis(1)}
                letter-spacing: 0;
                line-height: 34px;
            `,
        },
        hoverStyle: {
            color: getSystemColor("text.main"),
        },
        css: css`
            cursor: pointer;
            background-color: ${color("common.ui1", 0.25)};
            padding: 0 20px;
        `,
    },
};

export default headerAutoCompleteItemsStyles;
